import { render, staticRenderFns } from "./PaypalCard.vue?vue&type=template&id=a9e74910&scoped=true&"
import script from "./PaypalCard.vue?vue&type=script&lang=js&"
export * from "./PaypalCard.vue?vue&type=script&lang=js&"
import style0 from "./PaypalCard.vue?vue&type=style&index=0&id=a9e74910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e74910",
  null
  
)

export default component.exports